/*

VueJs Gegenstück zur MaterialTile.html aus Fluid

Merkzettel und Warenkorb müssen von der umgebenden Komponente gehandelt werden...

Events:
click => Klick auf Bild oder Titel
wishbtnclick => Klick auf Merkzettel-Stern
cartbtnclick => Klick auf Warenkorb-Button

Parameter:
entity == Object => Das Objekt, wie es vom Backend geliefert wird
showWishlist == Boolean => Wishlist-Feature aktivieren
in-wishlist == Boolean => Ob das Entit im Merkzettel liegt
showCart == Boolean => Cart-Feature aktivieren
in-cart == Boolean => Ob das Item bereits im Warenkorb ist


Slots:
Über die beiden Slots können zusätzliche Inhalte eingebracht werden

*/
<template>
    <div class="global-material-tile">
        <div class="tile--image-wrapper">
            <a class="tile--link" @click="onClick($event)" :href="entity.detail_link || entity.href">
                <img v-if="entity.image_src" :src="entity.image_src" class="tile--image img-fluid"/>
            </a>
            <span v-if="entity.three_viewer_config" class="geometry-viewer geometry-viewer--available open-three-d"
                  :data-decor="entity.three_viewer_config.decor" :data-structure="entity.three_viewer_config.structure"></span>
            <slot name="image-wrapper"/>
        </div>
        <div class="content-wrapper">
            <div class="tile-content">
                <span v-if="showWishlist && wishlistId" @click="onWishBtnClick" class="wish-list link link--secondary icon--small icon--before"
                      :class="{'icon--wishlist-empty': inWishlist !== true, 'icon--wishlist-filled': inWishlist}" :data-pid="wishlistId"
                      :data-title="entity.title" :data-titlesuffix="entity.titlesuffix" :data-subtitle="entity.subtitle"
                      :data-subsubtitle="entity.subsubtitle"></span>
                <a class="tile--link" @click="onClick($event)" :href="entity.detail_link || entity.href">
                    <p v-if="entity.title" class="tile--title"><b>{{ entity.title }}</b> {{ entity.titlesuffix }}</p>
                    <p v-if="entity.subtitle" class="tile--subtitle">{{ entity.subtitle }}</p>
                    <p v-if="entity.subsubtitle" class="tile--subtitle">{{ entity.subsubtitle }}</p>
                </a>
            </div>
            <div v-if="showCart && entity.order_pid" class="button-wrapper bottom left">
                <button :disabled="inCart" @click="onCartBtnClick" class="button button--secondary icon--before icon--shop "
                        :class="{'cart-available': inCart !== true, 'inactive': inCart}" :data-pid="entity.order_pid" :data-title="entity.title"
                        :data-titlesuffix="entity.titlesuffix" :data-subtitle="entity.subtitle" :data-subsubtitle="entity.subsubtitle">
                    {{ labelCartBtn }}
                </button>
            </div>
            <slot name="content-wrapper"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "globalMaterialTile",
    props: {
        entity: Object,
        inWishlist: Boolean,
        showWishlist: {
            type: Boolean,
            default: false
        },
        inCart: Boolean,
        showCart: {
            type: Boolean,
            default: false
        },
        disableLink: false
    },
    data: function() {
        return {
            labelCartBtn: window.pimLocalization.shop.tileCartBtn || ""
        };
    },
    computed: {
        wishlistId: function() {
            if (this.entity && (this.entity.type === 'P' || this.entity.type === 'G')) {
                return this.entity.subtype + '#' + this.entity.pim_id
            } else if (this.entity) {
                return this.entity.order_pid;
            }
            return false;
        }
    },
    methods: {
        onClick: function(event) {
            if (this.disableLink) {
                event.preventDefault();
            }

            if (this.$listeners.click) {
                event.preventDefault();
                this.$emit('click');
            }
        },
        onWishBtnClick: function() {
            // Hinwis: Innerhalb der normalen Webseite muss hier nichts
            this.$emit('wishbtnclick');
        },
        onCartBtnClick: function() {
            this.$emit('cartbtnclick');
        }
    }
}
</script>
